import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ActionSource } from "src/app/state/action-sources";

export const AddDiscountsModalActions = createActionGroup({
  source: ActionSource.ADD_DISCOUNTS_DIALOG,
  events: {
    'Discount Selected': props<{ discountId: string; amount: number }>(),
    'Amount Input Changed': props<{ amount: number }>(),
    'Event Selection Changed': props<{ eventIds: string[] }>(),
    'Cancel Button Clicked': emptyProps(),
    'New Single Use Button Clicked': emptyProps(),
    'Mutate Discount Dialog Opened': props<{ jobCode: string; eventIds: string[] }>(),
    'Apply Changes Button Clicked': props<{ amountTouched: boolean }>(),
    'Close Button Clicked': emptyProps(),
  },
});
